<template>
  <footer>
    <div class="d-lg-none">
      <div class="mt-auto">
        <div class="px-5 py-6">
          <EmbeddedSupportInfo v-if="contactInfoEnabled"/>
          <PoweredByLendio v-if="poweredByLendioEnabled" />
        </div>
        <div class="bottom-powered-by" v-if="poweredByLendioEnabled">
          <NuxtImg v-if="appNavLogo"
              :src="formatImagePath(appNavLogo)"
              alt="Powered By Lendio"
              class="pt-6 pb-4 px-3"
          />
        </div>
      </div>
    </div>
    <div v-if="privacyPolicyVisible" v-html="privacyPolicyHtml" class="px-xl-0 px-5 pt-4 mb-2 p-inline-xs"></div>
  </footer>
</template>
<script>
import EmbeddedSupportInfo from './EmbeddedSupportInfo.vue';
import PoweredByLendio from '~/components/PoweredByLendio.vue'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { mapState } from 'pinia'
import formatImagePath from '~/libs/image-format'

export default {
    name: "EmbeddedFooter",
    setup() {
      return { formatImagePath }
    },
    components: {
      EmbeddedSupportInfo,
      PoweredByLendio
    },
    computed: {
      ...mapState(useAffiliateCustomizationStore, [
        'appStyles',
        'contactInfoEnabled',
        'appNavLogo',
        'poweredByLendioEnabled',
        'privacyPolicyHtml',
        'privacyPolicyVisible'
      ]),
    },
}
</script>

<style lang="scss">
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';

footer {
  padding: 0 0 8px 0;
  @include media-breakpoint-up(xl) {
    padding: 0 64px 8px 64px;
  }
  p {
    font-size: 10px;
    color: $type-300;
  }

  a,
  a.link-primary {
    @include affiliateAppAnchorTag();
  }
}
</style>
